import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';

import { PF } from '@app/pages/Warehouses/ProductCategories/data';
import type { FiltersType } from '@app/pages/Warehouses/ProductCategories/types';

const FILTER = `${PF}_filters`;

export const Filters: FiltersType = ({
  unsavedValues: { SearchTerm },
  onChangeSearchTerm,
  skipSearchTerm,
  onSearch,
}) => (
  <div className={`${FILTER}_container`}>
    <Input
      addonBefore={<SearchOutlined />}
      placeholder="Введите название категории продукта"
      value={SearchTerm}
      onChange={onChangeSearchTerm}
      onPressEnter={onSearch}
      className={`${FILTER}_search`}
    />
    <div className={`${FILTER}_buttons`}>
      <Button
        htmlType="reset"
        onClick={skipSearchTerm}
        className={`${FILTER}_buttons_item`}
      >
        <CloseCircleOutlined />
        Сброс
      </Button>
      <Button
        type="primary"
        onClick={onSearch}
        className={`${FILTER}_buttons_item`}
      >
        Показать
      </Button>
    </div>
  </div>
);
